import { Breadcrumbs } from '@mui/material';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';

import styles from './NavigateLinks.module.css';

export type NavigateLink =
  | { label: string; to: string }
  | { label: string; onClick: () => void };

export interface NavigatePagesProps {
  actualPage: string;
  breadcrumbs: NavigateLink[];
}

const NavigateLinks = ({ actualPage, breadcrumbs }: NavigatePagesProps) => {
  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize='small' color={'secondary'} />}
      aria-label='breadcrumb'
    >
      {breadcrumbs.map((breadcrumb, index) =>
        'to' in breadcrumb ? (
          <Link
            key={breadcrumb.to}
            to={breadcrumb.to}
            className={styles.breadcrumb}
          >
            {breadcrumb.label}
          </Link>
        ) : (
          <h6
            key={`breadcrumb-onclick-${index}`}
            className={styles.breadcrumb}
            onClick={breadcrumb.onClick}
          >
            {breadcrumb.label}
          </h6>
        )
      )}
      <h6 key={breadcrumbs.length} className={styles.active}>
        {actualPage}
      </h6>
    </Breadcrumbs>
  );
};

export default NavigateLinks;
